import { render, staticRenderFns } from "./OtherPageWorkCard.vue?vue&type=template&id=74ba1bc2&scoped=true"
import script from "./OtherPageWorkCard.vue?vue&type=script&lang=js"
export * from "./OtherPageWorkCard.vue?vue&type=script&lang=js"
import style0 from "./OtherPageWorkCard.vue?vue&type=style&index=0&id=74ba1bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ba1bc2",
  null
  
)

export default component.exports